export enum WorkUnitDoneQualityCheckItemStatus {
  NotApproved = 0,
  Approved = 1,
}
